<button class="menu-button">

    <span class="icon-search_">
      <img src="../../../assets/icons/magnifier.svg" class="icon-menu" (click)="showFindPanel(!showFind)">
    </span>
  </button>


<button  *ngIf="libraryOn" class="menu-button cart" (click)="openLibraryPage()">
  <mat-icon matBadge="{{libraryItemsCount}}" [matBadgeHidden]="libraryHidden" matBadgePosition="above after" class="icon-shopping-cart_">
    <img src="../../../assets/icons/book.svg" class="icon-menu">
  </mat-icon>
</button>

  <button class="menu-button cart" (click)="openCartPage()">
    <mat-icon matBadge="{{productsCount}}" [matBadgeHidden]="hidden" matBadgePosition="above after" class="icon-shopping-cart_">
      <img src="../../../assets/icons/cart.svg" class="icon-menu">
    </mat-icon>
  </button>
<ng-template #dialog class="delete-dialog">
  <search-panel [show]="showFind" (closePanel)="showFindPanel($event)"></search-panel>
</ng-template>
